import { Box } from '@chakra-ui/react'
import React from 'react'
import './styles/footer.css'

const Footer = () => {
  return (
    <Box className='footer'>
      
    </Box>
  )
}

export default Footer
